import React from "react";
import PropTypes from "prop-types";
import { TableBody, TableCell, TableHead, TableRow, Grid, FormHelperText } from "@mui/material";
import { Button } from "@totalsoft/rocket-ui";
import { useTranslation } from "react-i18next";
import ContactModeRowComponent from "./ContactModeRowComponent";
import { isValid } from "@totalsoft/pure-validations-react";
import CardNoResultsWrapper from "components/layout/CardNoResultsWrapper";
import { MinWidthTable } from "components/common/TableStyles";

export const ContactModeListComponent = ({
  contactModeList,
  contactModes,
  validation,
  addContactMode,
  saveContactModes,
  deleteContactMode,
  onPropertyChange,
  partnerId,
  saveDisabled,
  validDefaultEmail,
  validDefaultMobilePhone,
  validDefaultPhone,
  hasWritePermission
}) => {
  const { t } = useTranslation();

  return (
    <Grid container sx={{ overflowX: "auto" }}>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <CardNoResultsWrapper content={contactModeList}>
          <MinWidthTable>
            <TableHead>
              <TableRow>
                <TableCell style={{ paddingRight: "150px" }} colSpan={4}>
                  {t("Partner.Type")}
                </TableCell>
                <TableCell style={{ paddingRight: "200px" }} colSpan={4}>
                  {t("Partner.Value")}
                </TableCell>
                <TableCell style={{ textAlign: "center" }} colSpan={2}>
                  {t("Partner.SMSNotification")}
                </TableCell>
                <TableCell style={{ textAlign: "center" }} colSpan={2}>
                  {t("ContactInfo.Default")}
                </TableCell>
                <TableCell colSpan={1}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {contactModeList?.map((document, idx) => {
                return (
                  <ContactModeRowComponent
                    key={idx}
                    idx={idx}
                    contactMode={document}
                    contactModes={contactModes}
                    validation={validation[idx]}
                    deleteContactMode={() => deleteContactMode(document)}
                    onPropertyChange={onPropertyChange(idx)}
                    hasWritePermission={hasWritePermission}
                  />
                );
              })}
            </TableBody>
          </MinWidthTable>
        </CardNoResultsWrapper>
        {!validDefaultEmail && (
          <FormHelperText error={true} id="name-error-text">
            {t("ContactInfo.ValidateUniqueDefaultEmail")}
          </FormHelperText>
        )}
        {!validDefaultMobilePhone && (
          <FormHelperText error={true} id="name-error-text">
            {t("ContactInfo.ValidateUniqueDefaultMobilePhone")}
          </FormHelperText>
        )}
        {!validDefaultPhone && (
          <FormHelperText error={true} id="name-error-text">
            {t("ContactInfo.ValidateUniqueDefaultPhone")}
          </FormHelperText>
        )}
        <Button
          id="contactMode_addBtn"
          color="primary"
          variant="contained"
          onClick={() => addContactMode()}
          disabled={!hasWritePermission}
          sx={{ marginTop: "1.5rem" }}
        >
          {t("Add")}
        </Button>
        <Button
          id="contactMode_saveBtn"
          variant="contained"
          color="primary"
          onClick={() => saveContactModes(partnerId, contactModeList)}
          disabled={!hasWritePermission || saveDisabled || !isValid(validation)}
          sx={{ marginLeft: ".25rem", marginTop: "1.5rem" }}
        >
          {t("Save")}
        </Button>
      </Grid>
    </Grid>
  );
};

ContactModeListComponent.propTypes = {
  contactModeList: PropTypes.array,
  contactModes: PropTypes.array.isRequired,
  addContactMode: PropTypes.func.isRequired,
  saveContactModes: PropTypes.func.isRequired,
  deleteContactMode: PropTypes.func.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired,
  partnerId: PropTypes.number,
  saveDisabled: PropTypes.bool,
  validDefaultEmail: PropTypes.bool,
  validDefaultMobilePhone: PropTypes.bool,
  validDefaultPhone: PropTypes.bool,
  hasWritePermission: PropTypes.bool.isRequired
};

export default ContactModeListComponent;
